import React from 'react';
import { Close } from './Buttons';
import { FaTimes } from "react-icons/fa";
import './pagetitle.css';

const PageTitle = ({ title, onClick, address, phone }) => {
  return (
    <div className='p-3 title-bg shadow-sm'>
      <div className='d-flex align-items-center justify-content-between mb-1'>
        <h5 className='bold text-white mb-0' style={{ fontSize: '18px', letterSpacing: '0.3px' }}>
          {title || "Alagar Crackers"}
        </h5>
        <Close label={<FaTimes size={16} />} onClick={onClick} />
      </div>

      {address && (
        <div className='regular text-white-50' style={{ fontSize: '12.5px', lineHeight: 1.4 }}>
          {address}
        </div>
      )}

      {phone && (
        <div className='regular text-warning mt-1' style={{ fontSize: '13px', fontWeight: 600 }}>
          📞 {phone}
        </div>
      )}
    </div>
  );
};

export default PageTitle;
